export default function A4Page({ children, type = 'dikey', customSize, ...props }) {
  // Yatay tip için kenar boşluklarını sıfırlıyoruz
  const paddingClasses = type === 'dikey' ? 'pl-[20mm] pt-[3mm]' : 'pt-[3mm]';

  // Eğer özel boyut varsa onu kullan
  const pageStyle = customSize
    ? { width: customSize.width, height: customSize.height }
    : type === 'dikey'
    ? { width: '210mm', height: '297mm' }
    : { width: '297mm', height: '210mm' }; // yatay A4

  return (
    <div
      style={pageStyle}
      className={`bg-white ${paddingClasses}`}
      {...props}
    >
      {type === 'dikey' ? (
        <div className="space-y-5">
          <div className="flex flex-wrap gap-3">{children}</div>
        </div>
      ) : (
        <div>
          <div>{children}</div>
        </div>
      )}
    </div>
  );
}
